let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("1oAGT"), load("5rr9F")]).then(() => parcelRequire('2uLtj'));